// extracted by mini-css-extract-plugin
export default {"logoWrapper":"styles_logoWrapper__EmRIo","logoText":"styles_logoText__PIVNO"};